// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__24IeJ","description":"PatientConsentPreview_description__2HXQm"};